import { useApolloClient, useSubscription } from '@apollo/client/react';

import { useUnreadNotificationCount } from 'common/hooks/useUnreadNotificationCount';
import {
    INotificationListItemFragment,
    NewNotificationDocument,
} from 'graphql/types';

/**
 * Subscribes to new notifications and updates the notification related cache.
 */
export const NewNotificationSubscription = () => {
    const client = useApolloClient();
    const { updateUnreadNotificationCount } = useUnreadNotificationCount();

    const updateNotificationCache = (
        notification: INotificationListItemFragment
    ) => {
        client.cache.modify({
            fields: {
                notifications(
                    existingNotifications = {
                        edges: [],
                        pageInfo: {},
                    },
                    { toReference }
                ) {
                    // Add the new notification to the beginning of the list
                    // and update the unread count
                    const newEdge = {
                        __typename: 'NotificationEdge',
                        node: toReference(notification),
                    };

                    return {
                        ...existingNotifications,
                        edges: [
                            newEdge,
                            ...(existingNotifications.edges || []),
                        ],
                    };
                },
            },
        });

        if (!!notification.readOn) return;

        updateUnreadNotificationCount(1);
    };

    useSubscription(NewNotificationDocument, {
        onData: ({ data: { data } }) => {
            const notification = data?.newNotification || undefined;

            if (!notification) return;

            updateNotificationCache(notification);
        },
    });

    return null;
};
